import { AppLayoutState, useAppLayoutStoreActions } from "PFApp/stores/app_layout_store";
import { headerOnly } from "PFCore/base/page_layouts";
import { useEffect } from "react";

const LEFT_PANEL_WIDTH = 500;
const LAYOUT_HORIZONTAL_PADDING = 24;
const NAVBAR_WIDTH = 60;

export const useEdgeToEdgeLayout = () => {
  const { setEdgeToEdge } = useAppLayoutStoreActions();

  useEffect(() => {
    setEdgeToEdge(true);
    return () => {
      setEdgeToEdge(false);
    };
  }, []);
};

type CalculateMainDimensionsParams = Pick<
  AppLayoutState,
  "layout" | "windowWidth" | "leftActionPanel" | "rightActionPanel" | "edgeToEdge"
>;

export const calculateMainDimensions = ({
  layout,
  windowWidth,
  leftActionPanel,
  rightActionPanel,
  edgeToEdge
}: CalculateMainDimensionsParams) => {
  if (!layout || layout === headerOnly) {
    return { mainLeft: 0, mainRight: 0, mainWidth: windowWidth, windowWidth };
  }

  const navShown = windowWidth > 500; // small screen => nav with a backdrop => doesn't affect the viewport
  const bothPanelsOpen = !leftActionPanel.collapsed && !rightActionPanel.collapsed;

  // feed seams to be the widest for now
  // but when we move feed panel to the leftActionPanel 1400 can be lowered!
  const isSmallScreen = windowWidth <= (bothPanelsOpen ? 1700 : 1400);

  let mainLeft =
    (navShown ? NAVBAR_WIDTH : 0) + (leftActionPanel.collapsed || isSmallScreen ? 0 : LEFT_PANEL_WIDTH);
  let mainRight = 0;

  if (!edgeToEdge) {
    mainLeft += LAYOUT_HORIZONTAL_PADDING;
    mainRight += LAYOUT_HORIZONTAL_PADDING;
  }

  return {
    mainLeft,
    mainRight,
    mainWidth: windowWidth - mainLeft - mainRight,
    windowWidth
  };
};
